"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var VALIDATOR_ARG_ERROR_MESSAGE = 'The typeValidator argument must be a function with the signature function(props, propName, componentName).';
var checkCondition = function checkCondition(condition, props, propName, componentName) {
  if (typeof condition === 'function') {
    return condition(props, propName, componentName);
  } else if (Boolean(condition) === true) {
    return Boolean(condition);
  }
  return false;
};
var propExists = function propExists(props, propName) {
  return Object.hasOwnProperty.call(props, propName);
};
var guardAgainstInvalidArgTypes = function guardAgainstInvalidArgTypes(typeValidator) {
  if (typeof typeValidator !== 'function') {
    throw new TypeError(VALIDATOR_ARG_ERROR_MESSAGE);
  }
};
var missingPropError = function missingPropError(props, propName, componentName) {
  return new Error("Required `".concat(propName, "` was not specified in `").concat(componentName, "`."));
};
var isRequiredIf = function isRequiredIf(typeValidator, condition) {
  guardAgainstInvalidArgTypes(typeValidator);
  return function (props, propName, componentName) {
    var validCondition = checkCondition(condition, props, propName, componentName);
    if (validCondition && !propExists(props, propName)) {
      return missingPropError(props, propName, componentName);
    }
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }
    return typeValidator.apply(void 0, [props, propName, componentName].concat(rest));
  };
};
var _default = isRequiredIf;
exports["default"] = _default;